import gql from 'graphql-tag';

export const setBaseCurrencyMutation = gql`
  mutation setBaseCurrency($id: Int) {
    setBaseCurrency(id: $id) {
      status
    }
  }
`;

export const updateCurrencyMutation = gql`
  mutation updateCurrency($id: Int, $isEnable: Boolean, $symbol: String) {
    updateCurrency(id: $id, isEnable: $isEnable, symbol: $symbol) {
      status
      errorMessage
    }
  }
`;

export const updatePayoutCurrencyMutation = gql`
  mutation updatePayoutCurrency(
    $id: Int
    $symbol: String
    $isPayoutCurrency: Boolean
  ) {
    updatePayoutCurrency(
      id: $id
      symbol: $symbol
      isPayoutCurrency: $isPayoutCurrency
    ) {
      status
      errorMessage
    }
  }
`;

export const getCurrencyRatesQuery = gql`
  {
    getCurrencyRates {
      base
      rates
    }
  }
`;

export const getBaseCurrencyQuery = gql`
  {
    getBaseCurrency {
      id
      symbol
    }
  }
`;

export const getCurrencyQuery = gql`
  query getCurrency($currentPage: Int, $searchList: String) {
    getCurrency(currentPage: $currentPage, searchList: $searchList) {
      count
      currencyList {
        id
        symbol
        isEnable
        isPayment
        isBaseCurrency
      }
    }
  }
`;
